import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { CommonUtilsService } from 'src/app/shared/services/common-utils.service';
import { ApiImportParamsService } from '../../service/api-import-params.service';
import { ApiImportParamOption, ApiImportParam } from '../../models/apiImportParams';
import { ConfirmationDialogBoxComponent } from 'src/app/shared/components/confirmation-dialog-box/confirmation-dialog-box.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-api-import-params',
  templateUrl: './api-import-params.component.html',
  styleUrls: ['./api-import-params.component.scss']
})
export class ApiImportParamsComponent implements OnInit {
  apiImportParams: ApiImportParam[] = [];
  apiImportParamsOrigin: ApiImportParam[] = [];
  spinnerFlag = true;
  hasChanges = false;
  @ViewChild(MatSort, {static: false}) sort: MatSort;


  constructor(
    private router: Router,
    private dialog: MatDialog,
    private apiImportParamsService: ApiImportParamsService,
    private commonUtils: CommonUtilsService,
    private translateService: TranslateService
  ) {
    this.getApiImportParams();
  }

  getApiImportParams() {
    this.apiImportParamsService.getApiImportParams().subscribe((response: ApiImportParam[]) => {
      this.spinnerFlag = false;
      this.setData(response);
    }, (error) => {
      this.spinnerFlag = false;
      this.commonUtils.errorSnackBar('error', '');
    });
  }
  ngOnInit() {
  }

  saveApiImportParams() {
    this.spinnerFlag = true;
    this.apiImportParamsService.saveApiImportParams(this.apiImportParams).subscribe((response: ApiImportParam[]) => {
      this.spinnerFlag = false;
      this.setData(response);
    }, (err: any) => {
      this.spinnerFlag = false;
      console.log(err);
      if (err.error.Result?.internalErrorCode == 40006) {
          this.commonUtils.errorSnackBar('error', this.translateService.instant('notAllowedToChangeAPiImportParamterWhileSubscriptionMode'));
      }
      else {
        this.commonUtils.errorSnackBar('error', this.translateService.instant('apiImportParamterSaveError'));
      }
    });
  }

  setData(data: ApiImportParam[]) {
    this.apiImportParams = data;
    //Create deep copy of orinal params for resetting
    this.apiImportParamsOrigin = JSON.parse(JSON.stringify(this.apiImportParams));
  }

  revertChanges() {
    if (this.hasChanges) {
      const dialogRef = this.dialog.open(ConfirmationDialogBoxComponent, {
        width: '400px'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.resetParams();
        }
      });
    }
    else {
      this.resetParams();
    }
  }

  resetParams() {
    this.apiImportParams = JSON.parse(JSON.stringify(this.apiImportParamsOrigin));
    this.hasChanges = false;
  }

  checkedChanged(param: ApiImportParamOption) {
    param.selected = !param.selected;
    this.hasChanges = true;
  }

  disableIfNoValueChanged() {
    return !this.hasChanges;
  }
}
